import { useEffect } from 'react'
import UserService from '../services/user.service'
import AuthService from '../services/auth.service'
import { setAuth } from '../common/Helpers';

const useGetUserPermission = (user_name, userPermissions, setUserPermissions) => {       
    useEffect(()=> {

        const getUserPermission = async (userName) => {

            try {
                const serviceResponse = await UserService.getPermission(userName);
                const response = serviceResponse.data;
                if (response.succeeded) {
                    setUserPermissions(response.data);
                }
                else {
                    setUserPermissions([]);
                }
            }
            catch (error) {
                setUserPermissions([]);
            }
        }

        if (user_name !== null && userPermissions === null) {
            getUserPermission(user_name)
        }
    
    }, [user_name, userPermissions, setUserPermissions]);
}
const useGetUserPermissionToCombobox = (user_name, userPermissions, setUserPermissions, setUserTypeId) => {       
    useEffect(()=> {

        const getUserPermission = async (userName) => {

            try {
                const serviceResponse = await UserService.getPermission(userName);
                const response = serviceResponse.data;
                if (response.succeeded) {
                    setUserPermissions(response.data.map(function(item) { return item.productId }));
                    setUserTypeId(response.data.length > 0 ? response.data[0].authRoleId : null)
                }
                else {
                    setUserPermissions([]);
                }
            }
            catch (error) {
                setUserPermissions([]);
            }
        }

        if (user_name !== null && userPermissions === null) {
            getUserPermission(user_name)
        }
    
    }, [user_name, userPermissions, setUserPermissions, setUserTypeId]);
}

const useGetUser = (user_name, setUser) => {       
    useEffect(()=> {

        const getUser = async (userName) => {
            try {
                const serviceResponse = await UserService.getUser(userName);
                const response = serviceResponse.data;
                setUser(response.data);
            }
            catch (error) {
            }
        }

        if (user_name !== null) {
            getUser(user_name)
        }
    
    }, [user_name, setUser]);
}

const useGetUserProfileCounters = (user_name, counters, setUserHeaderCounters) => {       
    useEffect(()=> {
        const getData = async (userName) => {

            try {
                const serviceResponse = await UserService.getContractAndRoleCounts(userName);
                const response = serviceResponse.data;
                setUserHeaderCounters(response.data);
            }
            catch (error) {
            }
        }

        if (user_name !== null && counters === null) {
            getData(user_name)
        }
    
    }, [user_name, counters, setUserHeaderCounters]);
}

const useGetExternalAccounts = (user_name, setGetExternalAccounts) => {       
    useEffect(()=> {
        const getData = async (userName) => {

            try {
                const serviceResponse = await UserService.getExternalLinkedAccounts(userName);
                const response = serviceResponse.data;
                setGetExternalAccounts(response.data);
            }
            catch (error) {
            }
        }

        if (user_name !== null) {
            getData(user_name)
        }
    
    }, [user_name, setGetExternalAccounts]);
}

const useGetExternalAccountsLinked = (user_name, setGetExternalAccounts) => {       
    useEffect(()=> {
        const getData = async (userName) => {

            try {
                const serviceResponse = await UserService.getExternalLinkedSimpleAccounts(userName);
                const response = serviceResponse.data;
                setGetExternalAccounts(response.data);
            }
            catch (error) {
            }
        }

        if (user_name !== null) {
            getData(user_name)
        }
    
    }, [user_name, setGetExternalAccounts]);
}

const useValidateUserExternalHash = (loginFrom, hash, result, idOp, status, setStatus, skh, setUrlRedirect, currentAuth) => {
    useEffect(()=> {
        const doItFinishVinculation = async () => {

            const externalLoginHashedModel =
            {
                idOp: idOp,
                userName: "",
                sg3LegacyPath: null,
                hashSG3Plus: hash,
                hashSG3Legacy: null,
                type: loginFrom.toLowerCase() === "legacy" ? "SG3" : "FIELDGLASS"
            };

            AuthService.validateExternalHash(externalLoginHashedModel).then(async (response) => {
                //Set auth value legacy true.
                //await setAuth(JSON.stringify(currentAuth));
         
                setStatus("OKH");

                setUrlRedirect("/#");  
            },
            (error) => {
                //[##]const _content = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                setStatus("NOOKH");
                setUrlRedirect("/");
            }).catch(() => {
                setStatus("NOOKH");
                setUrlRedirect("/");
            });
        }

        const doItExternalTransition = async () => {

            const externalLoginModel =
            {
                userName: "",
                hash: skh,
                type: "SG3"
            }

            AuthService.validateExternalLogin(externalLoginModel).then(async (response) => {
                if (response.data.data.tk) {
                    await setAuth(JSON.stringify(response.data.data));
                    setStatus("OKSKH");
                    setUrlRedirect("/|");
                }
                else {
                    setStatus("Error");
                    setUrlRedirect("Error");
                }
            },
            (error) => {
                //[##]const _content = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                setStatus("NOOKSKH");
                setUrlRedirect("/login");
            }).catch((err) => {
                console.log(err)
                setStatus("NOOKSKH");
                setUrlRedirect("/login");
            });
        }

        if (status === null) {
            if (skh !== null) {
                doItExternalTransition();
            }
            else if (loginFrom !== null && hash !== null && result !== null && idOp !== null) {
                if (result.toString().toLowerCase() === "true") {
                    doItFinishVinculation();
                }
                else {
                    setStatus("NOOK");
                    setUrlRedirect("/login");
                }
            }
            else {
                setStatus("NOOK");
                setUrlRedirect("/login");
            }
        }
    }, [loginFrom, hash, result, idOp, status, setStatus, skh, setUrlRedirect, currentAuth]);
}

export { useGetUserPermission, useGetUserPermissionToCombobox, useGetUser, useGetUserProfileCounters, useGetExternalAccounts, useGetExternalAccountsLinked, useValidateUserExternalHash }